type Payload = string | number | boolean | unknown[] | Record<string, unknown>

export const serverLogger = (payload: Payload): void => {
  void fetch('/spoe/api/v1/logs', {
    method: 'put',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(payload),
  }).catch((error) => console.error('Error:', error))
}
